import { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

export const useAccountPanelPresenter = () => {
  const managerInfo = useSelector((store) => store.user.accountManager);

  const [supportInfo, setSupportInfo] = useState({});
  const [accountInfo, setAccountInfo] = useState({});

  const composeSupportInfo = () => {
    const supInfo = {
      name: 'Техподдержка',
      phoneNumber: '74951201367',
      email: 'help-ecredit@business.auto.ru',
      avatarId: 'suppotIco',
      subtitle: 'На связи без выходных с 05:00 до 21:00 МСК',
      hasTelegram: 0,
      hasWhatsapp: 0,
    };
    setSupportInfo(supInfo);
  };

  const composeAccountInfo = useCallback(() => {
    const accInfo = { ...managerInfo, subtitle: 'На связи пн-пт с 10:00 до 19:00 МСК' };
    setAccountInfo(accInfo);
  }, [managerInfo]);

  useEffect(() => {
    composeSupportInfo();
    composeAccountInfo();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { supportInfo, accountInfo };
};
